import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\SAManagement\GetImportSourcesController::__invoke
* @see app/Http/Controllers/SAManagement/GetImportSourcesController.php
* @route '/api/sa-management/command-runner/import-sources'
*/
const GetImportSourcesController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetImportSourcesController.url(options),
    method: 'get',
})

GetImportSourcesController.definition = {
    methods: ["get","head"],
    url: '/api/sa-management/command-runner/import-sources',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SAManagement\GetImportSourcesController::__invoke
* @see app/Http/Controllers/SAManagement/GetImportSourcesController.php
* @route '/api/sa-management/command-runner/import-sources'
*/
GetImportSourcesController.url = (options?: RouteQueryOptions) => {
    return GetImportSourcesController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SAManagement\GetImportSourcesController::__invoke
* @see app/Http/Controllers/SAManagement/GetImportSourcesController.php
* @route '/api/sa-management/command-runner/import-sources'
*/
GetImportSourcesController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetImportSourcesController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SAManagement\GetImportSourcesController::__invoke
* @see app/Http/Controllers/SAManagement/GetImportSourcesController.php
* @route '/api/sa-management/command-runner/import-sources'
*/
GetImportSourcesController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetImportSourcesController.url(options),
    method: 'head',
})

export default GetImportSourcesController